import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import ContentLoading from "components/common/ContentLoading";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import apifetch from 'utils/apifetch';
import extractErrorMessage from "utils/extractErrorMessage";
import getBaseUrl from "utils/getBaseUrl";
import VendorSummary from '../../interfaces/VendorSummary';

interface State {
    isLoading: boolean;
    data: VendorSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class Index extends React.Component<RouteComponentProps<{}>, State> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
        this.deleteVendor = this.deleteVendor.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Vendors</BreadcrumbLink>
                </Breadcrumb>
                {this.state.errorMessage && (
                    <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                )}

                <div className="card card--datatables">
                    <div className="card-block">
                        <h2 className="card__title">Vendors</h2>
                        <div className="datatable-wrapper">
                            <DataTable
                                ajaxUrl={this.baseUrl + "api/vendors/summary"}
                                useAuth={true}
                                ajaxData={this.dataTableData}
                                ajaxDataFilter={this.dataTableDataFilter}
                                onDraw={this.handleDataTableDraw}
                                ref={this.mainDataTableRef}
                                stateSave={true}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: "15%" }}>ID</th>
                                        <th style={{ width: "20%" }}>Number</th>
                                        <th style={{ width: "40%" }}>Vendor Name</th>
                                        <th style={{ width: "24%" }}>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </DataTable>
                            {this.state.spinner ?
                                <ContentLoading />
                                :
                                <table className="d-none" ref={this.dataTableRef}>
                                    <tbody>
                                        {this.state.data.map((item, index) =>
                                            <tr key={item.id}
                                                id={`row-${item.id}`}
                                            >
                                                <td>{item.id}</td>
                                                <td>{item.vendorNo}</td>
                                                <td>{item.name}</td>
                                                <td>{item.description}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    public componentDidMount() {
        this.setState({
            isLoading: false
        });

        document.title = "Vendors - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "vendorNo",
            "name",
            "description"];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc"
                ? 1
                : 2,
            search: data.search.value,
            draw: data.draw,
        }

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<VendorSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    //private handleDataTableDraw(dataTable: any) {
    //    $(dataTable).find("a:not([href='#'])").click(e => {
    //        e.preventDefault();
    //        this.props.history.push($(e.currentTarget).attr("href")!);
    //    });
    //    $(dataTable).find(".btn-delete").click(e => {
    //        e.preventDefault();
    //        this.deleteVendor(parseInt($(e.currentTarget).attr("data-id")!, 10));
    //    });
    //}

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer");

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim();
            if (rowId) {
                this.props.history.push(`/vendors/${rowId}`);
            }
        });
    }

    private async deleteVendor(id: number) {
        this.setState({ errorMessage: undefined });
        if (window.confirm('Are you sure you wish to delete this item?')) {
            let response = await apifetch(`vendors/${id}`, {
                method: "DELETE",
            }, true);
            if (response.ok) {
                this.mainDataTableRef.current!.reload();
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({ errorMessage: errorText });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/vendors/Index.tsx